import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { getAllRatingandReviewsApi, getStoreReview } from './RatingAndReviewsApi';

// ----------------------------------------------------------------------

const initialState = {
  isRatingAndReviewsLoading: false,
  ratingAndReviewsList: [],
  hasMoreReviewData: true,
  isStoreReviewLoading: false,
  storeReview: [],
  reviewPageSize: 1000000
};

const slice = createSlice({
  name: 'rating',
  initialState,
  reducers: {
    increaseReviewPageNo: (state, action) => {
      state.reviewPageNo = action.payload;
    }
  },
  extraReducers: {
    [getAllRatingandReviewsApi.pending]: (state) => {
      state.isRatingAndReviewsLoading = true;
    },
    [getAllRatingandReviewsApi.fulfilled]: (state, action) => {
      state.ratingAndReviewsList = action.payload;
      state.isRatingAndReviewsLoading = false;
    },
    [getAllRatingandReviewsApi.rejected]: (state) => {
      state.isRatingAndReviewsLoading = false;
    },
    [getStoreReview.fulfilled]: (state, action) => {
      const { result = [], isAppend = false, hasMoreReviewData } = action.payload;
      state.hasMoreReviewData = hasMoreReviewData;
      state.isStoreReviewLoading = false;
      if (isAppend) {
        state.storeReview = _.concat(state.storeReview, result);
      } else {
        state.storeReview = result;
      }
    },
    [getStoreReview.pending]: (state, action) => {
      state.isStoreReviewLoading = true;
    },
    [getStoreReview.rejected]: (state, action) => {
      state.isStoreReviewLoading = false;
    }
  }
});
export const ratingAction = slice.actions;

export default slice.reducer;
